
jQuery( '.hero-banner.grid .card__images' ).slick( {
  infinite: true,
  speed: 600,
  cssEase: 'ease',
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  fade: true,
  autoplay: true,
  autoplaySpeed: 5000,
} );
